import {
  CALENDAR_GET_JOBS_LIST,
  CALENDAR_GET_ACCOUNT_MANAGERS_LIST,
  FORMAT_TASKS_FOR_TASK_VIEW
} from "../dataProvider/constant";

const INITIAL_STATE = {
  jobsList: [],
  accountManagersList: [],
  zones: [],
  accountManagers: [],
  stateNames: [],
  parentJobs: [],
  taskViewEvents: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CALENDAR_GET_JOBS_LIST:
      return {
        ...state,
        jobsList: action.jobs,
        stateNames: action.stateNames,
        zones: action.zones,
        parentJobs: action.parentJobs
      }
    case CALENDAR_GET_ACCOUNT_MANAGERS_LIST:
      return {
        ...state,
        accountManagersList: action.payload
      }
    case FORMAT_TASKS_FOR_TASK_VIEW:
      return {
        ...state,
        taskViewEvents: action.payload
      }
    default:
      return {
        ...state
      }
  }
}